import { render, staticRenderFns } from "./HistoryForm.vue?vue&type=template&id=e6fb346e"
import script from "./HistoryForm.vue?vue&type=script&lang=js"
export * from "./HistoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports